import { isBrowser } from './env';

export const hasDebugSwitch = (key: string) => {
  if (!isBrowser) return false;

  if (location.search.indexOf(key) !== -1) {
    return true;
  }
  if (localStorage.getItem(key)) {
    return true;
  }
  return false;
};
